(function () {
  var COMPANY = 'JeCshG';
  var LIST = 'MiYV9X'; // Newsletter subscribers list
  var EMAIL_SEL = '.hyer-bis__email, .hyer-nf__email';
  var MSG_SEL = '.hyer-bis__msg, .hyer-nf__msg';
  var currentEmail = '';
  var modal, boxMsg, rowEl, yesBtn, qEl, confirmEl;

  // Remember the last email typed in each notify form (input is cleared on success).
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches(EMAIL_SEL)) el.__hyerEmail = (el.value || '').trim();
  }, true);

  function subscribe(email) {
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Waitlist newsletter opt-in', profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } }, relationships: { list: { data: { type: 'list', id: LIST } } } } })
    });
  }

  function build() {
    if (modal) return;
    var style = document.createElement('style');
    style.textContent = '.hyer-optin-modal{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;background:rgba(26,26,26,.45);padding:20px}.hyer-optin-modal[hidden]{display:none}.hyer-optin-modal__box{position:relative;background:#fff;max-width:420px;width:100%;padding:36px 28px 28px;box-shadow:0 20px 60px rgba(0,0,0,.2);text-align:center}.hyer-optin-modal__close{position:absolute;top:10px;right:12px;background:none;border:none;font-size:24px;line-height:1;color:#8a8782;cursor:pointer;padding:4px}.hyer-optin-modal__confirm{font-size:14px;line-height:1.5;color:#1a1a1a;margin-bottom:16px}.hyer-optin-modal__q{font-size:15px;line-height:1.5;color:#1a1a1a;margin-bottom:22px}.hyer-optin-modal__row{display:flex;flex-direction:column;gap:12px;align-items:center}.hyer-optin-modal .hyer-optin-modal__yes{width:100%;height:48px;text-transform:uppercase;letter-spacing:.12em;font-size:11px}.hyer-optin-modal__no{background:none;border:none;color:#8a8782;font-size:12px;text-decoration:underline;cursor:pointer;padding:6px}.hyer-optin-modal__msg{margin-top:14px;font-size:14px;line-height:1.5;color:#1a1a1a}';
    document.head.appendChild(style);
    modal = document.createElement('div');
    modal.className = 'hyer-optin-modal';
    modal.setAttribute('hidden', '');
    modal.innerHTML = '<div class="hyer-optin-modal__box" role="dialog" aria-modal="true"><button type="button" class="hyer-optin-modal__close" aria-label="Close">×</button><div class="hyer-optin-modal__confirm">You’re on the list — we’ll email you the moment it’s back.</div><div class="hyer-optin-modal__q">Would you also like to subscribe to receive email updates on new releases?</div><div class="hyer-optin-modal__row"><button type="button" class="btn hyer-optin-modal__yes">Yes, sign me up</button><button type="button" class="hyer-optin-modal__no">No thanks</button></div><div class="hyer-optin-modal__msg" hidden></div></div>';
    document.body.appendChild(modal);
    boxMsg = modal.querySelector('.hyer-optin-modal__msg');
    rowEl = modal.querySelector('.hyer-optin-modal__row');
    qEl = modal.querySelector('.hyer-optin-modal__q');
    confirmEl = modal.querySelector('.hyer-optin-modal__confirm');
    yesBtn = modal.querySelector('.hyer-optin-modal__yes');
    modal.querySelector('.hyer-optin-modal__close').addEventListener('click', hide);
    modal.querySelector('.hyer-optin-modal__no').addEventListener('click', hide);
    modal.addEventListener('click', function (e) { if (e.target === modal) hide(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal && !modal.hasAttribute('hidden')) hide(); });
    yesBtn.addEventListener('click', function () {
      if (!currentEmail) { hide(); return; }
      yesBtn.disabled = true; yesBtn.textContent = 'Signing you up...';
      subscribe(currentEmail).then(function (r) {
        var ok = r && (r.ok || r.status === 202);
        qEl.style.display = 'none'; rowEl.style.display = 'none';
        boxMsg.hidden = false;
        boxMsg.textContent = ok ? 'You’re subscribed — thank you!' : 'Sorry, that didn’t work. Please try again.';
        if (ok) setTimeout(hide, 1800);
      }).catch(function () {
        qEl.style.display = 'none'; rowEl.style.display = 'none';
        boxMsg.hidden = false; boxMsg.textContent = 'Sorry, that didn’t work. Please try again.';
      });
    });
  }

  function reset() {
    qEl.style.display = ''; rowEl.style.display = '';
    boxMsg.hidden = true; boxMsg.textContent = '';
    yesBtn.disabled = false; yesBtn.textContent = 'Yes, sign me up';
  }

  function hide() { if (modal) modal.setAttribute('hidden', ''); }

  function showModal(email) { build(); reset(); currentEmail = email; modal.removeAttribute('hidden'); }

  function check(msgEl) {
    if (!msgEl || !msgEl.getAttribute) return;
    if (msgEl.hidden || msgEl.getAttribute('data-ok') !== '1') { msgEl.removeAttribute('data-optin-done'); return; }
    if (msgEl.getAttribute('data-optin-done') === '1') return;
    var root = (msgEl.closest && msgEl.closest('.hyer-bis, .hyer-nf, form')) || msgEl.parentNode;
    var input = root && root.querySelector(EMAIL_SEL);
    var email = input && (input.__hyerEmail || (input.value || '').trim());
    if (!email) return;
    msgEl.setAttribute('data-optin-done', '1');
    showModal(email);
  }

  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.matches && t.matches(MSG_SEL)) check(t);
      var added = muts[i].addedNodes || [];
      for (var j = 0; j < added.length; j++) {
        var n = added[j]; if (n.nodeType !== 1) continue;
        if (n.matches && n.matches(MSG_SEL)) check(n);
        if (n.querySelectorAll) n.querySelectorAll(MSG_SEL).forEach(check);
      }
    }
  });
  obs.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-ok', 'hidden'] });
  document.querySelectorAll(MSG_SEL).forEach(check);
})();
